import { Phone, Mail, MapPin, Instagram, Facebook } from "lucide-react";
import { CONTACT_INFO, SOCIAL_LINKS } from "@/config/constants";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className="relative bg-[#192338] py-16 border-t border-[#DDC385]/20 overflow-hidden"
      data-testid="footer"
    >
      {/* Background dinâmico com opacidade reduzida para o efeito Premium */}
      <div className="absolute inset-0 bg-gradient-to-b from-transparent to-[#DDC385]/5 pointer-events-none" />

      <div className="container mx-auto px-4 md:px-6 max-w-7xl relative z-10">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          {/* Identidade: Logo APS e Títulos com espaçamento personalizado */}
          <div className="flex flex-col items-start">
            <div className="group relative flex items-center mb-6 cursor-default">
              {/* Box da Logo: Moldura com efeito Glow no hover */}
              <div className="relative w-12 h-12 bg-[#192338] border border-[#DDC385]/40 flex items-center justify-center transition-all duration-500 group-hover:border-[#DDC385] shadow-xl">
                <div className="flex flex-col items-center">
                  <span className="text-[#DDC385] font-serif font-bold text-lg leading-none tracking-tighter">
                    APS
                  </span>
                  {/* Divisor interno em gradiente */}
                  <div className="w-8 h-[1px] bg-gradient-to-r from-transparent via-[#DDC385] to-transparent mt-0.5" />
                </div>
                {/* Brilho sutil (Glow) de fundo */}
                <div className="absolute inset-0 bg-[#DDC385]/10 opacity-0 group-hover:opacity-100 transition-opacity duration-700 blur-sm" />
              </div>

              {/* Tipografia: Padrão de tracking largo para os títulos */}
              <div className="ml-3 flex flex-col">
                <span className="text-[10px] tracking-[0.4em] text-white/50 uppercase font-light">
                  Administrativo
                </span>
                <span className="text-[8px] tracking-[0.2em] text-[#DDC385]/70 uppercase">
                  Premium Management
                </span>
              </div>
            </div>

            <p className="text-white/60 text-sm leading-relaxed max-w-xs">
              Soluções administrativas especializadas com as cores e o rigor que
              sua empresa exige.
            </p>
          </div>

          {/* Seção de Contato: Estilo institucional dourado */}
          <div>
            <div className="text-[11px] tracking-[0.3em] uppercase text-[#DDC385] font-semibold mb-6">
              Contato
            </div>
            <div className="space-y-4 text-white/70 text-sm">
              <a
                href={CONTACT_INFO.phoneLink}
                className="flex items-center gap-3 hover:text-[#DDC385] transition-colors group"
              >
                <Phone
                  size={14}
                  className="text-[#DDC385]/80 group-hover:text-[#DDC385]"
                />
                {CONTACT_INFO.phone}
              </a>
              <a
                href={CONTACT_INFO.emailLink}
                className="flex items-center gap-3 hover:text-[#DDC385] transition-colors group"
              >
                <Mail
                  size={14}
                  className="text-[#DDC385]/80 group-hover:text-[#DDC385]"
                />
                {CONTACT_INFO.email}
              </a>
              <div className="flex items-start gap-3">
                <MapPin
                  size={14}
                  className="text-[#DDC385]/80 mt-1 flex-shrink-0"
                />
                <span className="leading-relaxed">
                  {CONTACT_INFO.address.street}
                  <br />
                  {CONTACT_INFO.address.city}, {CONTACT_INFO.address.cep}
                </span>
              </div>
            </div>
          </div>

          {/* Social: Cards com borda suave e efeito de preenchimento */}
          <div>
            <div className="text-[11px] tracking-[0.3em] uppercase text-[#DDC385] font-semibold mb-6">
              Siga-nos
            </div>
            <div className="flex gap-4">
              {[
                { icon: Instagram, link: SOCIAL_LINKS.instagram },
                { icon: Facebook, link: SOCIAL_LINKS.facebook },
              ].map((social, idx) => (
                <a
                  key={idx}
                  href={social.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-11 h-11 border border-[#DDC385]/20 flex items-center justify-center relative overflow-hidden group transition-all duration-500 hover:border-[#DDC385]/60"
                >
                  <social.icon className="w-4 h-4 text-[#DDC385]/60 group-hover:text-[#DDC385] transition-colors duration-300 z-10" />
                  <div className="absolute inset-0 bg-[#DDC385]/5 opacity-0 group-hover:opacity-100 transition-opacity" />
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Rodapé: Linha de gradiente centralizada e copyright discreto */}
        <div className="pt-10 border-t border-white/5 flex flex-col items-center gap-4">
          <div className="w-24 h-px bg-gradient-to-r from-transparent via-[#DDC385]/40 to-transparent" />
          <p className="text-white/30 text-[10px] tracking-[0.2em] uppercase">
            © {currentYear} APS Administrativo — Todos os direitos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};
